import React from 'react'

import { useErrorModal } from '~/components/maple/pages/item/error-modal-context'
import { EmptyShoppingCart } from '../../icons/empty-shopping-cart'

export const useShoppingCartError = () => {
  const { showError } = useErrorModal()
  // TODO: Add localization
  const showShoppingCartError = () =>
    showError(
      EmptyShoppingCart,
      'Whoops!',
      'There was an error completing your request.\n' +
        'Please wait a moment and try again.',
    )
  return { showShoppingCartError }
}
